const getCookie = (name: string) => {
  if (typeof document === 'undefined') {
    return null
  }
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
  return v ? v[2] : null
}

export default getCookie
